/* eslint-disable */

import { toCurrency } from '../../utils/CurrencyUtil'
import MFNavbar from '../../Components/MutualFunds/MFNavbar'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../Components/ui/dialog'
import { Button } from '../../Components/ui/button'
import { MobileSearchInput } from '../../Components/ui/mobile-search-input'
import env from '../../env/env'
import { isDematUser } from '../../utils/AuthUtil'
import { useEffect, useState } from 'react'
import useDebounce from '../../hooks/useDebounce'
import { MFRecentlyViewed } from '../../store/MFStore'
import { useRecoilValueLoadable } from 'recoil'
import { get } from '../../http/restservice'
import { useNavigate } from 'react-router-dom'

const MFTopNavbar = () => {
  const navigate = useNavigate()
  const [searchData, setSearchData] = useState([])
  const [query, setQuery] = useState('')
  const [searchLoading, setSearchLoading] = useState(false)
  const debouncedSearchTerm = useDebounce(query, 500)
  const [isOpen, setIsOpen] = useState(false)

  const handleSearchOpen = () => {
    setIsOpen(!isOpen)
  }

  const handleSearchCancel = () => {
    setIsOpen(false)
    setQuery('')
  }

  useEffect(() => {
    const searchFunds = async () => {
      setSearchLoading(true)
      const response = await get(
        `/mutualfundservice/api/mfData/allFunds?search=${debouncedSearchTerm}`,
      )
      setSearchLoading(false)

      if (response.isError) {
        setSearchData([])
      }

      if (!response.isError) {
        setSearchData(response?.funds)
      }
    }

    if (debouncedSearchTerm) {
      searchFunds()
    } else {
      setSearchData([])
    }
  }, [debouncedSearchTerm])

  const handleFabStarNavigate = (fund) => {
    setIsOpen(false)

    navigate(`/dashboard/mutual-funds/details`, {
      state: {
        fundDetails: fund,
        schemeCode: fund.schemeCode,
      },
    })
  }

  return (
    <div
      className='py-2'
      style={{
        background:
          'radial-gradient(83.35% 187.05% at 21.03% 89.97%, #1B243B 0%, #242F4E 40.06%, #3B4D80 100%)',
        isolation: 'isolate',
      }}
    >
      <MFNavbar handleSearchOpen={handleSearchOpen} />

      <Dialog
        open={isOpen}
        onOpenChange={handleSearchOpen}
        aria-labelledby='dialog-title'
        aria-describedby='dialog-description'
      >
        <DialogContent className='font-DMSans h-full w-screen md:h-[50vh] duration-300 ease-out flex flex-col justify-start border rounded-none overflow-y-scroll hide-scrollbar'>
          <DialogHeader>
            <DialogTitle>
              <div className='flex items-center mb-4'>
                <MobileSearchInput
                  placeholder='Search for funds'
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  handleSearchCancel={handleSearchCancel}
                />
              </div>
            </DialogTitle>
          </DialogHeader>

          {!debouncedSearchTerm && isDematUser() && (
            <div className='flex flex-col'>
              <div className='flex gap-x-2 items-center'>
                <Button
                  variant='simple'
                  size='simple'
                  onClick={() => {
                    handleSearchCancel(), navigate('/dashboard/mutual-funds/orders')
                  }}
                  className={`rounded-full font-medium text-xs border border-primary-200 px-4 py-2 bg-background text-primary-500`}
                >
                  Orders
                </Button>
                <Button
                  variant='simple'
                  size='simple'
                  onClick={() => {
                    handleSearchCancel(), navigate('/dashboard/mutual-funds/sips')
                  }}
                  className={`rounded-full font-medium text-xs border border-primary-200 px-4 py-2 bg-background text-primary-500`}
                >
                  SIPs
                </Button>
                <Button
                  variant='simple'
                  size='simple'
                  onClick={() => {
                    handleSearchCancel(), navigate('/dashboard/mutual-funds/investments')
                  }}
                  className={`rounded-full font-medium text-xs border border-primary-200 px-4 py-2 bg-background text-primary-500`}
                >
                  Investments
                </Button>
              </div>
            </div>
          )}

          {/* {!debouncedSearchTerm && recentlyViewed?.state != 'hasValue' && (
            <div className='mt-5'>
              <h2 className='font-semibold text-primary-700 leading-6 tracking-[-4%]'>
                Fabstar funds
              </h2>
              <div>
                {fabStarFunds.state === 'hasValue' &&
                  fabStarFunds?.contents?.data?.map((fund) => (
                    <div
                      className='cursor-pointer flex gap-x-2 items-center py-4 border-b-[1px] border-primary-50'
                      key={fund?.amcCode}
                      onClick={() => handleFabStarNavigate(fund)}
                    >
                      <img
                        src={`${env.MF_LOGOS_URL}/${fund?.amcCode}.png`}
                        className='h-9 w-9 rounded-sm'
                      />

                      <div className='w-full'>
                        <div className='flex justify-between'>
                          <h2 className='font-semibold leading-5 text-sm text-black-500 text-nowrap'>
                            {fund?.legalName
                              ? fund?.legalName?.slice(0, 25)
                              : fund?.sName?.slice(0, 25)}
                            ...
                          </h2>

                          <p
                            className={`font-semibold leading-5 text-sm text-secondary-600 text-nowrap`}
                          >
                            {fund?.threeYrRet.toFixed(2)}% <span className='text-xs'>(3Y)</span>
                          </p>
                        </div>
                        <p className='text-xs text-black-400 font-medium leading-4'>
                          Starts at{' '}
                          <span className='text-xs text-black-500 font-semibold'>
                            ₹ {toCurrency(fund?.minInvt)}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {!debouncedSearchTerm && (
            <div className='mt-5'>
              <h2 className='font-semibold text-primary-700 leading-6 tracking-[-4%]'>
                Recently viewed funds
              </h2>
              <div>
                {fabStarFunds.state === 'hasValue' &&
                  fabStarFunds?.contents?.data?.map((fund) => (
                    <div
                      className='cursor-pointer flex gap-x-2 items-center py-4 border-b-[1px] border-primary-50'
                      key={fund?.amcCode}
                      onClick={() => handleFabStarNavigate(fund)}
                    >
                      <img
                        src={`${env.MF_LOGOS_URL}/${fund?.amcCode}.png`}
                        className='h-9 w-9 rounded-sm'
                      />

                      <div className='w-full'>
                        <div className='flex justify-between'>
                          <h2 className='font-semibold leading-5 text-sm text-black-500 text-nowrap'>
                            {fund?.legalName
                              ? fund?.legalName?.slice(0, 25)
                              : fund?.sName?.slice(0, 25)}
                            ...
                          </h2>

                          <p
                            className={`font-semibold leading-5 text-sm text-secondary-600 text-nowrap`}
                          >
                            {fund?.threeYrRet.toFixed(2)}% <span className='text-xs'>(3Y)</span>
                          </p>
                        </div>
                        <p className='text-xs text-black-400 font-medium leading-4'>
                          Starts at{' '}
                          <span className='text-xs text-black-500 font-semibold'>
                            ₹ {toCurrency(fund?.minInvt)}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )} */}

          {searchLoading && (
            <div className='max-h-[50vh] flex justify-center items-center text-primary-500'>
              Loading...
            </div>
          )}

          {debouncedSearchTerm && !searchLoading && searchData.length === 0 && (
            <div className='max-h-[50vh] flex justify-center items-center text-primary-500'>
              No funds available
            </div>
          )}

          {debouncedSearchTerm && (
            <div className='max-h-[70vh] overflow-y-scroll'>
              {searchData.map((fund) => (
                <div
                  className='cursor-pointer flex gap-x-2 items-center py-4 border-b-[1px] border-primary-50'
                  key={fund?.amcCode}
                  onClick={() => handleFabStarNavigate(fund)}
                >
                  <img
                    src={`${env.MF_LOGOS_URL}/${fund?.amcCode}.png`}
                    className='h-9 w-9 rounded-sm'
                  />

                  <div className='w-full'>
                    <div className='flex justify-between'>
                      <h2 className='font-semibold leading-5 text-sm text-black-500 text-nowrap'>
                        {fund?.legalName
                          ? fund?.legalName?.slice(0, 25)
                          : fund?.sName?.slice(0, 25)}
                        ...
                      </h2>

                      <p
                        className={`font-semibold leading-5 text-sm text-secondary-600 text-nowrap`}
                      >
                        {fund?.threeYrRet.toFixed(2)}% <span className='text-xs'>(3Y)</span>
                      </p>
                    </div>
                    <p className='text-xs text-black-400 font-medium leading-4'>
                      Starts at{' '}
                      <span className='text-xs text-black-500 font-semibold'>
                        ₹ {toCurrency(fund?.minInvt)}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default MFTopNavbar
